// extracted by mini-css-extract-plugin
export var container = "_jx-0";
export var segment = "_jx-2";
export var segmentActive = "_jx-3";
export var track = "_jx-1";